import styled from 'styled-components';

export const ErrorMessageContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  text-align: center;
  margin: 50px 0 50px;
  color: ${({ theme }) => theme.palette.primary};
`;

export const ErrorTitle = styled.p`
  font-size: 1.5rem;
`;

export const ErrorDescription = styled.p`
  color: ${({ theme }) => theme.palette.text.primary};
  font-size: 1rem;
`;
